module.exports = __webpack_public_path__ + "img/senalando-izqca.f7263dd4.png";